import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App'
import EpisodePage from './pages/EpisodePage'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/episodes/:id" element={<EpisodePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
